import { useState } from "react";
import SideMenu from "./SideMenu/SideMenu";
import ContentChannel from "./ChannelManagment/ContentChannel/ContentChannel";
import ContentPreview from "./ChannelManagment/ContentPreview/ContentPreview";
import DeleteContent from "./ChannelManagment/DeleteContent/DeleteContent";
import FreeContent from "./FreeContent/FreeContent";
import AddFreeContent from "./FreeContent/AddFreeContent/AddFreeContent";
import EditContent from "./ChannelManagment/EditContent/EditContent";
import LogOutBox from "./SideMenu/SubSideMenu/LogOutBox";
import ModalFilterFreeContent from "./FreeContent/FilterFreeContent/ModalFilterFreeContent";
import filterItem from "../Data/DataFilterFreeContent";
import UserManagment from "./UserManagment/UserManagment";
import Users from "./Users/Users";
import BrandManagment from "./BrandManagment/BrandManagment";

function Dashboard() {

    const [contentPreview, setContentPreview] = useState("")
    const [contentDelete, setContentDelete] = useState("")
    const [contentEdit, setContentEdit] = useState("")
    const [activeTab, setActiveTab] = useState(2)
    const [addContent, setAddContent] = useState(false)
    const [showLogOut, setShowLogOut] = useState("")
    const [openFilterContent, setOpenFilterContent] = useState(false)

    const chooseContentDelete = (value) => {
        setContentDelete(value)
    }
    const chooseContentPreview = (value) => {
        setContentPreview(value)
    }

    const contentForEdit = (value) => {
        setContentEdit(value)
    }

    return (
        <>
            <div className="bg-purpleLight w-full h-full flex flex-row-reverse pb-10">
                <SideMenu activeTab={activeTab} setActiveTab={setActiveTab} openModal={setShowLogOut} />

                {filterItem.socialNetwork}

                <div className="w-5/6 h-screen bg-white flex flex-col shadow rounded-r-2xl my-2 ml-2 pb-4">
                    {activeTab === 0 ?
                        <ContentChannel
                            chooseContent={chooseContentPreview}
                            contentForDelete={chooseContentDelete}
                            contentForEdit={contentForEdit}
                        />
                        :
                        activeTab === 1 ?
                            <FreeContent AddNewContent={setAddContent} OpenFilter={setOpenFilterContent} />
                            :
                            activeTab === 2 ?
                                <UserManagment />
                                :
                                activeTab === 3 ?
                                    <Users />
                                    :
                                    activeTab === 4 ?
                                        <BrandManagment />
                                        :
                                        null
                    }
                </div>
            </div>
            {contentPreview &&
                <ContentPreview contentPreview={contentPreview} closeModal={setContentPreview} />
            }
            {contentDelete &&
                <DeleteContent contentDelete={contentDelete} closeModal={setContentDelete} />
            }
            {addContent &&
                <AddFreeContent closeModal={setAddContent} />
            }
            {contentEdit &&
                <EditContent item={contentEdit} closeModal={setContentEdit} />
            }
            {showLogOut &&
                <LogOutBox closeModal={setShowLogOut} />
            }
            {openFilterContent &&
                <ModalFilterFreeContent closeModal={setOpenFilterContent} />
            }
        </>
    )
}
export default Dashboard;